import React from "react";

import { createField } from "../selectField";
import { Select } from "shared/components/select";
import { useTranslate } from "../translate";
import { useFetchImproveAreas } from "./hooks";

const SelectImproveAreas = (props) => {
  const translate = useTranslate();
  const [loading, options] = useFetchImproveAreas();

  return (
    <Select
      {...props}
      isLoading={loading}
      options={options}
      getOptionValue={(val) => val?.id}
      getOptionLabel={(val) => translate(`enums.improveAreas.${val.name}`)}
      menuPlacement="bottom"
      menuPosition="fixed"
    />
  );
};

export default createField(SelectImproveAreas);
